import { getData, postData } from '@/utils/http'
import config from '@/config'
export default {
	namespaced: true,
	state: {
		tableLoading: true,
		addLoading: false,
		activeItem: null,
		tableList: [],

		//查询条件
		pageIndex: 1,
		total: 0,
		projectId: '',
		orderId: '',
		waybillId: '',
		deptId:"",
	},
	mutations: {
		CHANGE_TABLE_LOADING(state, tableLoading) {
			state.tableLoading = tableLoading
		},
		CHANGE_ADD_LOADING(state, addLoading) {
			state.addLoading = addLoading
		},
		CHANGE_TABLE_DATA(state, changeData) {
			state.tableList = changeData.data.rows
			state.total = changeData.total
		},
		CHANGE_ACTIVE_ITEM(state, item) {
			state.activeItem = item
		},
		CHANGE_SEARCH_COLL(state, changeData) {
			if (changeData['changeKey'] == 'orgId' && typeof changeData['data'] != 'object') {
				state[changeData['changeKey']] = [changeData['data']]
			} else {
				state[changeData['changeKey']] = changeData['data']
			}
		},
		CHANGE_TABLE_INDEX(state, value) {
			state.pageIndex = value
		}
	},
	actions: {
		//获取超时运单列表
		getList({ commit, state }) {
			
			return new Promise(resolve => {
				//如果没有订单id就不查询了
				if (!state.orderId) {
					commit('CHANGE_TABLE_DATA', {
						data:{
							rows:[]
						},
						total:0
					})
					resolve({
						state: 0,
						msg: "暂无订单数据"
					})
				}else{
					getData(`logistics/waybill/timeout/page`, {
						projectId: state.projectId,
						orderId: state.orderId,
						page: state.pageIndex,
						size: config.pageSize
					}).then(res => {
						if (res.state == 1) {
							commit('CHANGE_TABLE_DATA', res)
							resolve({
								state: 1,
								msg: '操作成功'
							})
						} else {
							resolve({
								state: 0,
								msg: res.msg
							})
						}
					})
				}

			})
		},

		//获取我的项目列表
		getMyProjectList({ commit, state },deptId) {
			return new Promise(resolve => {
				getData(`logistics/project/my/list?deptId=${deptId}`).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: '操作成功',
							data: res.data
						})
					} else {
						resolve({
							state: 0,
							msg: res.msg,
							data: []
						})
					}
				})
			})
		},
		//获取对应订单列表
		getMyOrderList({ commit, state }) {
			const query = {
				projectId: state.projectId,
				page:1,
				size:9999,
				status: 0
			}
			return new Promise(resolve => {
				getData(`logistics/order/page`, query).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: '操作成功',
							data: res.data
						})
					} else {
						resolve({
							state: 0,
							msg: res.msg,
							data: []
						})
					}
				})
			})
		},

		//运单超时消除
		removeWaybillOvertime({ commit, state }, id) {
			return new Promise(resolve => {
				getData(`logistics/waybill/timeout/handler/${id}`).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							data: res.data,
							msg: '消除成功'
						})
					} else {
						resolve({
							state: 0,
							data: null,
							msg: res.msg
						})
					}
				})
			})
		},

		//获取运单详情
		getWaybillDetails({ commit, state }) {
			return new Promise(resolve => {
				getData(`/logistics/waybill/details/${state.activeItem.waybillId}`).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							data: res.data,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: null,
							msg: res.msg
						})
					}
				})
			})
		},

		getAllowOrg({ commit, state }, year) {
			return new Promise((resolve) => {
				getData(`logistics/sys/dept/get/list`).then((res) => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: "操作成功",
							data: res.data
						});
					} else {
						resolve({
							state: 0,
							msg: res.msg,
							data: []
						});
					}
				})
			})
		},


		//写入当前操作条目
		setActiveItem({ commit }, item) {
			commit('CHANGE_ACTIVE_ITEM', item)
		},

		//写入查询条件
		setSearchData({ commit }, changeData) {
			commit('CHANGE_SEARCH_COLL', changeData)
		},
		//修改分页
		setPageIndex({ commit }, value) {
			commit('CHANGE_TABLE_INDEX', value)
		},
		//修改添加loading
		changeAddLoading({ commit }, value) {
			commit('CHANGE_ADD_LOADING', value)
		},
		//修改添加loading
		changeListLoading({ commit }, value) {
			commit('CHANGE_TABLE_LOADING', value)
		}
	}
}
